import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { NotificationTable } from './Notification';
import { Link } from 'react-router-dom';
import { UserContext } from './App';
import NotificationService, {
  NotificationItem,
} from '#/services/NotificationService';

function Dashboard() {
  const ctx = useContext(UserContext);
  const service = new NotificationService(ctx.userInfo!);
  const [notifications, setNotifications] = useState<NotificationItem[]>();

  useEffect(() => {
    service.getList({ current: 0, limit: 30 }).then((res) => {
      setNotifications(res.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
        <div className="container-xl px-4">
          <div className="page-header-content pt-1">
            <div className="row align-items-center justify-content-between">
            </div>
          </div>
        </div>
      </header>
      <div className="container-xl px-4 mt-n10">
        <div className="card mb-4">
          <div className="card-body">
            <Row>
              <Col>
                <Stack direction="horizontal">
                  <span className="fs-4">親機登録数</span>
                  <span className="fs-4">：</span>
                  <span className="fs-4">{ctx.userInfo!.device_count?.owner || 0}</span>
                </Stack>
                <Stack direction="horizontal">
                  <span className="fs-4">子機登録数</span>
                  <span className="fs-4">：</span>
                  <span className="fs-4">{ctx.userInfo!.device_count?.child || 0}</span>
                </Stack>
              </Col>
            </Row>
            <Row>
              <Col className="mt-4">
                <p className="fs-4">通知履歴</p>
              </Col>
            </Row>
            <Row className="border">
              <Col className="p-2">{NotificationTable(ctx.userInfo!, notifications)}</Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <p className="text-end">
                  <Link to="/notification" className="text-decoration-none">
                    もっとみる&nbsp;
                    <i className="bi bi-chevron-right"></i>
                  </Link>
                </p>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
